import React from 'react';
import PropTypes from 'prop-types';

function ReviewBulkAlertBox(props) {
  const {
    alertCount,
    thresholdName,
    thresholdDetails,
    showTags,
    tagsText,
    notificationGroupsText,
    hasActions,
  } = props;

  return (
    <div className="alert alert-success" role="alert">
      <div>
        You are about to create
        {' '}
        <strong>
          {alertCount}
          {' '}
          new alerts
        </strong>
        {' '}
        with the threshold
        {' '}
        <strong>
          {thresholdName}
          {' '}
        </strong>
        {thresholdDetails}
        {' '}
        {showTags && (
          <>
            and these tags:
            {' '}
            <strong>{tagsText}</strong>
          </>
        )}
        .
      </div>
      {
        hasActions && (
        <div className="mt-2">
          These alerts will send notifications, as configured, to
          {' '}
          <strong>{notificationGroupsText}</strong>
          .
        </div>
        )
      }
    </div>
  );
}

ReviewBulkAlertBox.propTypes = {
  alertCount: PropTypes.number.isRequired,
  thresholdName: PropTypes.string.isRequired,
  thresholdDetails: PropTypes.string.isRequired,
  showTags: PropTypes.bool.isRequired,
  tagsText: PropTypes.string.isRequired,
  notificationGroupsText: PropTypes.string.isRequired,
  hasActions: PropTypes.bool.isRequired,
};

export default ReviewBulkAlertBox;
